/**
 * scFetch — wraps browser fetch for the SC Labs Python backend (/fivem/* endpoints).
 * In dev mode, Vite proxies these to 127.0.0.1:8082.
 * Auth is handled via txAdmin session cookies (credentials: 'include').
 */
export async function scGet<T = unknown>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: 'include' });
  if (!res.ok) throw new Error(`SC API ${path} → ${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

export async function scPost<T = unknown>(path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: body instanceof FormData ? undefined : { 'Content-Type': 'application/json' },
    body: body instanceof FormData ? body : (body ? JSON.stringify(body) : undefined),
  });
  if (!res.ok) throw new Error(`SC API ${path} → ${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

export async function scDelete<T = unknown>(path: string): Promise<T> {
  const res = await fetch(path, { method: 'DELETE', credentials: 'include' });
  if (!res.ok) throw new Error(`SC API ${path} → ${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}
